import React from "react";
import { Container } from "react-bootstrap";
import { AiOutlineDownload } from "react-icons/ai";

const resumePath = process.env.PUBLIC_URL + "/Resume_DebojyotiRoy.pdf";

function ResumeSection() {
  return (
    <section className="section resume-section">
      <Container>
        <h2 className="section-title fade-in">
          My <span className="purple">Resume</span>
        </h2>

        <div className="resume-btn fade-in fade-in-delay-1">
          <a
            href={resumePath}
            target="_blank"
            rel="noreferrer"
            className="btn-primary-custom"
            download
          >
            <AiOutlineDownload /> Download Resume
          </a>
        </div>

        <div className="resume-embed fade-in fade-in-delay-2">
          <iframe
            src={resumePath}
            title="Debojyoti Roy Resume"
          />
        </div>

        <p className="resume-download-note fade-in fade-in-delay-3">
          If the PDF doesn't load, click the download button above.
        </p>
      </Container>
    </section>
  );
}

export default ResumeSection;
